import Tether from 'tether';
import ResizeObserver from 'resize-observer-polyfill';

(function() {
	document.addEventListener('DOMContentLoaded', () => {
		const dropdowns = document.getElementsByClassName('dropdown-wrapper');

		for (const dropdown of dropdowns) {
			const target = dropdown.getElementsByClassName('dropdown-wrapper__target')[0];
			const container = dropdown.getElementsByClassName('dropdown-wrapper__container')[0];

			const tether = new Tether({
				element: container,
				target: target,
				attachment: 'top left',
				targetAttachment: 'bottom left',
				constraints: [
					{
						to: 'window',
						pin: ['left', 'right'],
					},
				],
			});

			tether.position();

			// Handle target div resizing
			const ro = new ResizeObserver(() => {
				tether.position();
			});

			ro.observe(target);
		}
	});
})();
